module.exports = __webpack_public_path__ + "img/texture-brick-2-top-blank.456d85a6.jpg";